// @flow

export const RECOVERY = 'RECOVERY'
export const RECOVERY_SUCCESS = 'RECOVERY_SUCCESS'
export const RECOVERY_ERROR = 'RECOVERY_ERROR'
export const RECOVERY_RESET = 'RECOVERY_RESET'
